<template>
  <div class="table-responsive">
    <!-- Filtrado de la tabla -->
    <filter-table
      :filtro="filtro"
      :pagination="pagination"
      :dataLength="dataLength"
      :perPage="perPage"
      :showExportToExcel="showExportToExcel"
      :showExportToPdf="showExportToPdf"
      @buscar="buscar"
      @generar="generar"
      @generarCompleto="generarCompleto"
      @set-pages="setPerPage"
      @filter="filter"
      :disableGenerar="disableGenerar"
      :SetectFiltro="SetectFiltro"
      :showButtonBuscar="showButtonBuscar"
      :showButtonBorrar="showButtonBorrar"
      :showButtonGenerar="showButtonGenerar"
      :showSelectFiltro="showSelectFiltro"
      :showFilterEstadoGarantia="showFilterEstadoGarantia"
      :EstadoGarantia="EstadoGarantia"
      :showFilterModelos="showFilterModelos"
      :showFilterTipoDoc="showFilterTipoDoc"
      :Modelos="Modelos"
      :TipoArchivo="TipoArchivo"
      :showFilterConvenios="showFilterConvenios"
      :Convenios="Convenios"
      :showFilterDates="showFilterDates"
      :showFilterCedula="showFilterCedula"
      :showFilterPagare="showFilterPagare"
      :showFilterCaseNumber="showFilterCaseNumber"
      :showFilterCaseName="showFilterCaseName"
      :loadGenerar="loadGenerar"
      :showButtonGenerarHistorico="showButtonGenerarHistorico"
    />
    <br />
    <h3 v-if="showMessage && message != ''">{{ message }}</h3>
    <table id="general-table" class="table table-hover table-vcenter">
      <thead>
        <tr>
          <slot name="label"></slot>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td :colspan="fields.length" class="text-center" v-if="loading">
            <img src="@/assets/images/loader.gif" alt />
          </td>
          <td
            :colspan="fields.length"
            class="text-center"
            v-if="(data.Length || data) == 0 && !loading"
          >
            No se encontraron datos
          </td>
        </tr>
        <template v-if="!loading">
          <tr
            v-for="(row, index) in displayed"
            :key="index"
            v-bind:class="{
              'table-info': row.info,
              'table-warning': row.warning,
              'table-danger': row.danger,
              'table-primary': row.primary,
              'table-success': row.success,
              'table-light': row.light,
            }"
          >
            <template v-for="(field, _index) in fields">
              <td
                :key="_index"
                :class="
                  $children.filter(
                    (e) => e.$options._componentTag == 'table-column'
                  )[_index].$options.propsData.customClass
                "
                :style="
                  $children.filter(
                    (e) => e.$options._componentTag == 'table-column'
                  )[_index].$options.propsData.customStyle
                "
              >
                <template v-if="String(field).includes('checkbox:')">
                  <b-form-group>
                    <b-form-checkbox
                      v-model="checkbox"
                      v-bind:value="row[field.split(':')[1]]"
                      :key="row[field.split(':')[1]]"
                      name="checkbox"
                    ></b-form-checkbox>
                  </b-form-group>
                </template>

                <template v-if="field">
                  <template
                    v-if="
                      $children.filter(
                        (e) => e.$options._componentTag == 'table-column'
                      )[_index].$options.propsData.filter
                    "
                    >{{
                      format(
                        field.split(".").reduce((a, b) => a[b], row),
                        $children.filter(
                          (e) => e.$options._componentTag == "table-column"
                        )[_index].$options.propsData.filter,
                        _index
                      )
                    }}</template
                  >
                  <template v-else>{{
                    field.split(".").reduce((a, b) => a[b], row)
                  }}</template>
                </template>

                <template v-if="!field">
                  <div
                    class="btn-container d-flex justify-content-center"
                    v-if="actions[_index]"
                  >
                    <template v-for="(action, i) in actions[_index]">
                      <button
                        :class="action.class"
                        data-toggle="dropdown"
                        v-if="validarIcon(action,row)"
                        :key="i"
                        @click="clickEvent(row, action.attrs.slug)"
                        v-tooltip.top="action.attrs.tooltip"
                        :disabled="
                          action.attrs.customActive
                            ? !action.attrs.customActive.includes(
                                row['estado'].toLowerCase()
                              )
                            : false
                        "
                      >
                        <i :class="action.attrs.icon"></i>
                      </button>
                    </template>
                  </div>
                </template>
              </td>
            </template>
          </tr>
        </template>
      </tbody>
    </table>

    <nav
      aria-label="..."
      class="mt-5"
      v-if="pagination && this.data.length > 0"
    >
      <ul class="pagination">
        <li class="page-item" v-bind:class="page != 1 ? '' : 'disabled'">
          <a class="page-link" @click="setPages(page - 1, true)" tabindex="-1"
            >&#8249;</a
          >
        </li>

        <li class="page-item" disabled v-if="page > 5">
          <a class="page-link" @click="setPages(1, true)" tabindex="-1"
            >1 ...</a
          >
        </li>

        <li
          class="page-item"
          v-for="(pageNumber, index) in pages"
          :key="index"
          @click="setPages(pageNumber, true)"
          v-bind:class="page == pageNumber ? 'active' : ''"
        >
          <a class="page-link">{{ pageNumber }}</a>
        </li>

        <li class="page-item" disabled v-if="numberOfPages - 4 > page">
          <a
            class="page-link"
            @click="setPages(numberOfPages, true)"
            tabindex="-1"
            >... {{ numberOfPages }}</a
          >
        </li>

        <li
          class="page-item"
          v-bind:class="page < pages.length ? '' : 'disabled'"
        >
          <a class="page-link" @click="setPages(page + 1, true)">&#8250;</a>
        </li>
        <li
          class="page-item"
          v-if="showExportToExcel"
          v-bind:class="loading ? 'disabled' : ''"
        >
          <a class="page-link" @click="exportToExcel">Exportar a Excel</a>
        </li>
        <li
          class="page-item"
          v-if="showExportToPdf"
          v-bind:class="loading ? 'disabled' : ''"
        >
          <a class="page-link" @click="exportToPdf">Exportar a PDF</a>
        </li>
      </ul>
    </nav>
      <b-modal
        id="modal-base-operaciones"
        title="Información base operaciones"
        hide-footer
        size="xl"
      >
        <div class="m-3">
          <div class>
            <p class="mb-5 text-justify">
            <!-- <b>Icono circular:</b> a través de esta opcíón, se puede descargar la base de garantizados al último corte contable.
              <br />-->
            Actualmente tiene un informe de base operaciones en estado EN COLA o PROCESANDO, si desea generar uno nuevo, favor esperar que finalice.
            </p>
            <!-- <div class="container">
              <br />
              <div class="form-group">
                <b-button
                  type="button"
                  variant="primary"
                  :disabled="loading"
                  class="ml-1"
                  >Guardar</b-button
                >
              </div>
              <br />
              &nbsp;
            </div> -->
          </div>
        </div>
      </b-modal>
  </div>
</template>
<script>
import Vue from "vue";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import SelectComponet from "@/components/form/Select.vue";

export default {
  name: "TableComponent",
  data: () => {
    return {
      es: es,
      dateInicio: new Date(),
      dateFin: new Date(),
      selected: null,
      page: 1,
      pages: [],
      fields: [],
      actions: [],
      nRows: 0,
      numberOfPages: 0,
      checkbox: [],
      disableGenerar: false
    };
  },
  props: {
    data: {
      default: () => [],
      type: [Array, Function],
    },
    pagination: {
      default: () => false,
      type: Boolean,
    },
    dataLength: {
      default: () => 0,
      type: Number,
    },
    perPage: {
      default: () => 10,
    },
    SetectFiltro: {
      default: () => [],
      type: Array,
    },
    showButtonBuscar: {
      default: () => true,
      type: Boolean,
    },
    showButtonBorrar: {
      default: () => true,
      type: Boolean,
    },
    showButtonGenerar: {
      default: () => false,
      type: Boolean,
    },
    EstadoGarantia: {
      default: () => [],
      type: Array,
    },
    Modelos: {
      default: () => [],
      type: Array,
    },
    TipoArchivo: {
      default: () => [],
      type: Array,
    },
    Convenios: {
      default: () => [],
      type: Array,
    },
    filtro: {
      default: () => false,
      type: Boolean,
    },
    showSelectFiltro: {
      default: () => false,
      type: Boolean,
    },
    showFilterEstadoGarantia: {
      default: () => false,
      type: Boolean,
    },
    showFilterModelos: {
      default: () => false,
      type: Boolean,
    },
    showFilterTipoDoc: {
      default: () => false,
      type: Boolean,
    },
    showFilterConvenios: {
      default: () => false,
      type: Boolean,
    },
    showFilterDates: {
      default: () => false,
      type: Boolean,
    },
    showFilterCedula: {
      default: () => false,
      type: Boolean,
    },
    showFilterPagare: {
      default: () => false,
      type: Boolean,
    },
    filterCedula: {
      default: () => "",
      type: String,
    },
    filterPagare: {
      default: () => "",
      type: String,
    },
    showFilterCaseNumber: {
      default: () => false,
      type: Boolean,
    },
    showFilterCaseName: {
      default: () => false,
      type: Boolean,
    },
    showExportToExcel: {
      default: () => false,
      type: Boolean,
    },
    showExportToPdf: {
      default: () => false,
      type: Boolean,
    },
    showMessage: {
      default: () => false,
      type: Boolean,
    },
    message: {
      default: () => "",
      type: String,
    },
    checkEstado: {
      default: () => false,
      type: Boolean
    },
    loadGenerar:{
      default: () => false,
      type: Boolean
    },
    checkedModalBase:{
      default: () => false,
      type: Boolean
    },
    showButtonGenerarHistorico:{
      default: () => false,
      type: Boolean
    }
  },
  components: {
    SelectComponet,
    Datepicker,
    FilterTable: () => import("@/components/table/FilterTable"),
  },
  computed: {
    displayed() {
      return this.paginate(this.data);
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  methods: {
    format(value, filter) {
      return Vue.filter(filter)(value);
    },
    buscar(params) {
      this.$emit("click-buscar", params);
    },
    generar(params) {
      this.disableGenerar = true
      this.$emit("click-generar", params);
    },
    generarCompleto(params){
      this.$emit("click-generarCompleto", params);
    },
    clickEvent(row, slug) {
      this.$emit("click-event", row, slug);
    },
    paginate(rows) {
      let page = this.page;
      let perPage = this.nRows;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return rows;
    },
    setPages(page, click = false) {
      this.page = page === undefined ? 1 : page;

      if (click) {
        this.$emit(
          "click-event",
          { nRows: this.nRows, page: this.page },
          "paginacion"
        );
      }

      this.pages = [];
      this.numberOfPages = Math.ceil(this.dataLength / this.nRows);

      if (this.page > this.numberOfPages && this.numberOfPages != 0) {
        return this.setPages(1, true);
      }

      let rango_inicial =
        this.page <= 5
          ? 1
          : this.page - 4 - (this.page + 5 > this.numberOfPages ? 5 : 0);
      let rango_final =
        this.page + 5 > this.numberOfPages
          ? this.numberOfPages
          : this.page + 4 + (this.page < 5 ? 5 - this.page : 0);

      for (let index = rango_inicial; index <= rango_final; index++) {
        this.pages.push(index);
      }
    },
    exportToExcel() {
      this.$emit(
        "click-event",
        { nRows: this.nRows, page: this.page },
        "export-to-excel"
      );
    },
    exportToPdf() {
      this.$emit(
        "click-event",
        { nRows: this.nRows, page: this.page },
        "export-to-pdf"
      );
    },
    setPerPage(perPage) {
      this.nRows = perPage;

      this.setPages(this.page, true);
    },
    filter(filter) {},
    validarIcon(action,row){
      return  action.attrs.customVisible ? (action.slot == 'icon' && action.attrs.customVisible.includes(row['estado'])):(action.slot == 'icon');
    },
  },
  watch: {
    data() {
      if(this.checkEstado){
        let disabled = false
        this.data.map( dato => {
          if(dato.estado != 'FINALIZADO' && dato.estado != 'NO SE ENCONTRARON REGISTROS'){
            disabled = true
          }
        })
        if(disabled){
          this.disableGenerar = true
          if(this.checkedModalBase){
            this.$root.$emit("bv::show::modal", "modal-base-operaciones", "#btnShow");
            setTimeout(() => {
              this.$root.$emit("bv::hide::modal", "modal-base-operaciones", "#btnShow");
            }, "4500");
          }
        }else{
          this.disableGenerar = false
        }
      }
      this.setPages(this.page);
    },
    nRows(newVal) {
      this.setPages(this.page);
    },
    checkbox() {
      this.$emit("checkbox", this.checkbox);
    },
  },
  mounted() {
    this.nRows = this.perPage;
    if (this.$slots.label != undefined) {
      this.$slots.label.forEach((e, i) => {
        this.fields.push(e.data.attrs.value);
        if (
          e.componentOptions.children &&
          e.componentOptions.children.length > 0
        ) {
          this.actions[i] = [];
          e.componentOptions.children.forEach((_e) => {
            this.actions[i].push(_e.data);
          });
        }
      });
    }

    this.setPages(1);
  },
};
</script>
